import { usePathname } from "next/navigation";

export const useIsContractDraft = () => {
  const pathname = usePathname() as string | undefined;
  return pathname?.includes("/draft/welcome") === true;
};
